import {
    byteArrayToBase64,
    stringToUtf8Bytes,
} from '@qdabra/infopath-attachments';
import { OCTET_STREAM_MIME_TYPE, getMimeTypeForFileName } from './mime.helpers';

const tryAnchorDownload = (fileBytes, fileName) => {
    const aElement = document.createElement('a');

    if ('download' in aElement) {
        aElement.setAttribute('download', fileName);
        aElement.href = `data:${OCTET_STREAM_MIME_TYPE};base64,${byteArrayToBase64(
            fileBytes,
        )}`;

        document.body.appendChild(aElement);

        const event = document.createEvent('MouseEvents');
        event.initMouseEvent(
            'click',
            true,
            false,
            self,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null,
        );

        aElement.dispatchEvent(event);
        document.body.removeChild(aElement);

        return true;
    }

    return false;
};

const trySaveAsDownload = (fileBytes, fileName) => {
    if (self.saveAs) {
        const blob = new Blob([fileBytes], { type: OCTET_STREAM_MIME_TYPE });

        self.saveAs(blob, fileName);

        return true;
    }

    return false;
};

// (UIntArray, String) -> Boolean
export const initiateFileDownload = (fileBytes, fileName) =>
    trySaveAsDownload(fileBytes, fileName) ||
    tryAnchorDownload(fileBytes, fileName);

// (String, String) -> Boolean
export const initiateTextFileDownload = (text, fileName) => {
    const bytes = stringToUtf8Bytes(text);

    return initiateFileDownload(bytes, fileName);
};

export const openFileInBrowser = (fileBytes, fileName) => {
    const blob = new Blob([fileBytes], {
        type: getMimeTypeForFileName(fileName),
    });
    const url = URL.createObjectURL(blob);

    const newWindow = window.open(url);

    newWindow.document.title = fileName;
};
